module.exports = __webpack_public_path__ + "img/logo.381e7413.png";